import { Directive, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { AttachmentTypeService } from '../types/attachment-type-service'

@Directive({
  selector: '[appAttachmentTypeSelect]',
})
export class AttachmentTypeSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private select = inject(ElderSelectComponent)
  private attachmentTypeService = inject(AttachmentTypeService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.displayProperty = 'name'
    this.select.placeholder = 'attachments.type'
    this.select.dataSource = this.attachmentTypeService
    this.select.sorts = [new Sort('name', 'asc')]
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public clear(): void {
    this.select.clear(undefined)
  }
}
